import { calculateIsTimeLeft } from './calculateIsTimeLeft';
import { getEndOfToday } from './getEndOfToday';
import { useCountdownTimer } from './useCountdownTimer';

export function useEndOfTheDayCountdownTimer() {
  const offerUntil = getEndOfToday().toISOString();
  const { countdownTime } = useCountdownTimer({ offerUntil });
  return {
    isTimeLeft: calculateIsTimeLeft(countdownTime),
    timeDetails: countdownTime,
  };
}
